import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataStoreService {
  
   public emailText = '';

  constructor() { }
  
  updateText(text: string) {
    this.emailText = text;
    console.log(this.emailText);
  }

  resetText() {
    this.emailText = '';
  }
  wtf() {
    console.log('wtf');
  }


}
